import type { GetDtcCodeResponseItem } from '@packages/clients';

import type { DtcCodeEntity } from '../entities';

/**
 * Map a DTC code search result DTO to a `DtcCodeEntity`. Renames DTO fields
 * (`dtcCode`, `dtcCodeId`) to the entity's canonical names (`code`, `id`).
 *
 * @param dto - the raw DTC code response item from the search API
 * @returns the mapped entity
 */
export function toDtcCodeEntity(dto: GetDtcCodeResponseItem): DtcCodeEntity {
    return {
        code: dto.dtcCode,
        description: dto.description,
        id: dto.dtcCodeId,
    };
}
